import React from "react";
import { toTitleCase } from "src/services/string.service";
import globalTheme from "src/theme";
import { IProduct } from "src/types/product";
import styled from "styled-components";

const Detail = styled.h2`
  padding: 4px 16px 12px 16px;
  font-size: ${globalTheme.fontSizes.regular};
  font-family: ${globalTheme.fonts.regular};
  text-align: center;
`;

interface IProps {
  product: IProduct;
  hideSubTitle?: boolean;
}

const ProductSubtitle = ({
  product,
  hideSubTitle,
}: IProps): JSX.Element | null => {
  if (
    !hideSubTitle &&
    (product.strength || product.productSubFamily || product.originCountry)
  ) {
    return (
      <Detail>
        {`${product.strength ? parseFloat(product.strength) + "%" : ""}${
          product.productSubFamily
            ? `, ${toTitleCase(product.productSubFamily || "")}`
            : ""
        }${
          product.originCountry
            ? `, ${toTitleCase(product.originCountry || "")}`
            : ""
        }`}
      </Detail>
    );
  }

  return null;
};

export default ProductSubtitle;
